import React, { useContext } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  // DialogContentText,
  DialogTitle,
  Grid,
  TextField,
} from '@material-ui/core';

import { Formik } from 'formik';

import PropTypes from 'prop-types';

import BasicButton from '../buttons/basicButton';
import SpinnerLoading from '../feedback/spinnerLoading';
// import ResetPasswordForm from './resetPasswordForm';

import { changePassword } from '../../utils/comms';

import { changePasswordVS } from '../../utils/formValidations';
import translations from '../../languages/i18n';

import { SessionContext } from '../../utils/context';

export default function ChangePasswordDialog({ handleClose, handleFeedback, idUser, open, title }) {
  const sessionContext = useContext(SessionContext);

  const closeForm = (handleReset) => {
    handleReset();
    handleClose();
  };

  const submitPassword = async ({
    newPassword,
    resetForm,
  }) => {
    const response = await changePassword({ password: newPassword }, idUser, sessionContext.userToken);
    if (response.status === 200) { // Password creat/modificat
      resetForm();
      handleClose();
      handleFeedback('success', 'ChangePassword');
    } else if (response === 'timeOut') { // El servidor està caigut o l'usuari no té connexió
      handleFeedback('error', 'TimeOut');
    } else { // Error amb les dades o al servidor
      handleFeedback('error', 'ChangePassword');
    }
  };

  return (
    <div>
      <Formik
        initialValues={{ currentPassword: '', newPassword: '', confirmPassword: '' }}
        validationSchema={changePasswordVS}
        onSubmit={(
          { newPassword },
          { resetForm },
        ) => submitPassword({
          newPassword,
          resetForm,
        })}
      >
        {({ values, touched, errors, handleChange, handleBlur, handleSubmit, handleReset, isValid, isSubmitting, submitForm }) => (
          <form id='' onSubmit={handleSubmit}>
            <Dialog
              open={open}
              aria-labelledby='alert-dialog-title'
              aria-describedby='alert-dialog-description'
              fullWidth
              maxWidth='sm'
            >
              <DialogTitle id='alert-dialog-title'>{title}</DialogTitle>
              <DialogContent>
                <SpinnerLoading show={isSubmitting} />
                <Grid container spacing={2} justify='space-around' direction='column'>
                  {/* <Grid item xs={12}>
                    <TextField
                      required
                      fullWidth
                      type='password'
                      variant='outlined'
                      id='currentPassword'
                      name='currentPassword'
                      label={translations['_currentPassword']}
                      error={Boolean(touched.currentPassword && errors.currentPassword)}
                      value={values.currentPassword}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      helperText={touched.currentPassword && errors.currentPassword ? errors.currentPassword : ''}
                    />
                  </Grid> */}
                  <Grid item xs={12}>
                    <TextField
                      required
                      fullWidth
                      type='password'
                      variant='outlined'
                      id='newPassword'
                      name='newPassword'
                      label={translations['_newPassword']}
                      error={Boolean(touched.newPassword && errors.newPassword)}
                      value={values.newPassword}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      helperText={touched.newPassword && errors.newPassword ? errors.newPassword : ''}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      required
                      fullWidth
                      type='password'
                      variant='outlined'
                      id='confirmPassword'
                      name='confirmPassword'
                      label={translations['_confirmPassword']}
                      error={Boolean(touched.confirmPassword && errors.confirmPassword)}
                      value={values.confirmPassword}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      helperText={touched.confirmPassword && errors.confirmPassword ? errors.confirmPassword : ''}
                    />
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <BasicButton handleClick={submitForm} type='accept' /> {/* Per enviar el formulari des d'un botó meu, sinó s'ha d'emprar un Button type='submit' */}
                <BasicButton handleClick={() => closeForm(handleReset)} type='cancel' />
              </DialogActions>
            </Dialog>
          </form>
        )}
      </Formik>
    </div>
  );
}

// Indica i controla els props que se han de passar al component
ChangePasswordDialog.propTypes = {
  idUser: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleFeedback: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};
